import React from 'react'
import AllCompaniesDashboard from './components/AllCompaniesDashboard'

const AllCompaniesApp: React.FC = () => {
  return <AllCompaniesDashboard />
}

export default AllCompaniesApp
